import { CLOUDINARY_PREFIX, MOCK_UP_LAYERS } from '../constants';

const { IMAGE_LAYER, VARIATION_LAYER, GRADIENT_LAYER } = MOCK_UP_LAYERS;

const CUP_LIGHT = `${CLOUDINARY_PREFIX}82e0b3c059b1193c908259cf4c23fc1e-1577716232737/Light.png`;
const CUP_BASE = `${CLOUDINARY_PREFIX}82e0b3c059b1193c908259cf4c23fc1e-1577716232727/Base%20Image.png`;
const CUP_HIGHLIGHTS = `${CLOUDINARY_PREFIX}82e0b3c059b1193c908259cf4c23fc1e-1577716232740/Highlights.png`;
const BUSINESS_CARD = `${CLOUDINARY_PREFIX}82e0b3c059b1193c908259cf4c23fc1e-1577716232725/Business%20card.png`;

const VARIATION_TRANSFORM = 'translate(-60.0%, -32%) rotate(-19deg) scale(0.35)';

export const cupMockUpSquare = {
    layers: [
        {
            type: IMAGE_LAYER,
            src: CUP_BASE,
        },
        {
            type: GRADIENT_LAYER,
            mixBlendMode: 'multiply',
            gradientType: 'linear',
        },
        {
            type: VARIATION_LAYER,
            transform: VARIATION_TRANSFORM,
        },
        {
            type: VARIATION_LAYER,
            transform: VARIATION_TRANSFORM,
            opacity: 0.2,
            mixBlendMode: 'multiply',
        },
        {
            type: IMAGE_LAYER,
            src: BUSINESS_CARD,
        },
        {
            type: IMAGE_LAYER,
            opacity: 0.8,
            mixBlendMode: 'overlay',
            src: CUP_HIGHLIGHTS,
        },
        {
            type: IMAGE_LAYER,
            opacity: 0.44,
            mixBlendMode: 'screen',
            src: CUP_LIGHT,
        },
    ],
    aspectRatio: '100%',
};
